import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { RequireAuth } from "@/features/auth";
import { RobotLandingScrollGuard } from "./components/RobotLandingScrollGuard";

const ResponsiveRobotPage = lazyWithRetry(
  () => import("./pages/ResponsiveRobotPage"),
);

// issue #185: RobotLandingScrollGuard is a pathless layout route nested under
// RequireAuth. It renders an <Outlet /> for the four robot pages and snaps
// scrollY to 0 on entry (including refresh/back POP), since these routes live
// outside DashboardLayout and inherit no scroll restoration otherwise.
const routes: RouteObject[] = [
  {
    Component: RequireAuth,
    children: [
      {
        Component: RobotLandingScrollGuard,
        children: [
          { path: "/", Component: ResponsiveRobotPage },
          { path: "/robot", Component: ResponsiveRobotPage },
          { path: "/robot-config", Component: ResponsiveRobotPage },
          { path: "/ai", Component: ResponsiveRobotPage },
        ],
      },
    ],
  },
];

export default routes;
